module.exports = __webpack_public_path__ + "static/media/Igo.c2f344de.png";